// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"476":"4eca474d","770":"ea70c013","787":"9c9a6da6"}[chunkId] + ".chunk.js";
};